import { EVENT_ADDON_ITEM_TYPE } from '../../../../../../../../../constants/event-items';
import { getAsset } from '../../../../../../../../../util/assets';

export const GIFTING_EVENT_ADDON_ITEMS_META = {
  [EVENT_ADDON_ITEM_TYPE.WALDOFIED]: {
    title: 'Live Event Album',
    description:
      'Contains a live slideshow, printable QR signages, AI photo tagging & delivery for ALL guests, and more!',
    thumbnailSrc: getAsset(`/waldofied-thumbnail.png`),
    previewSrc: 'https://d1ldwnjkukjs70.cloudfront.net/waldofied-preview.jpg',
    howItWorks: {
      assetUrl: getAsset('/photo-albums-how-it-works.gif'),
    },
  },
  [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
    title: 'Memories Smart Slideshow',
    description:
      'Let Waldo help collect old photos from family & friends and turn them into a Memories Slideshow!',
    thumbnailSrc: getAsset(`/memory-book-thumbnail.png`),
    previewSrc: 'https://d1ldwnjkukjs70.cloudfront.net/memory-book-preview.jpg',
    howItWorks: {
      header: 'How it works:',
      assetUrl: getAsset('/memory-book-how-it-works.gif'),
    },
  },
  [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
    title: 'Video Guestbook',
    description:
      'All the well wishes from guests in one digital Video Guestbook!',
    thumbnailSrc: getAsset(`/vgb-thumbnail.png`),
    previewSrc: 'https://d1ldwnjkukjs70.cloudfront.net/vgb-preview.jpg',
    howItWorks: {
      header: 'How it works:',
      assetUrl: getAsset('/vgb-how-it-works.gif'),
    },
  },
};
